import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

declare const $: any;

@Component({
  selector: 'app-help-video-modal',
  templateUrl: './help-video-modal.component.html',
  styleUrls: ['./help-video-modal.component.css']
})
export class HelpVideoModalComponent {
  dialog: MatDialogRef<any>;
  helpLink: string = "";

  constructor(
    public dialogRef: MatDialogRef<any>
  ) {
    this.dialog = dialogRef;
  }

  ngOnInit() {

  }
}